import Snap from 'snapsvg-cjs'
import store from '../store'
import { Bus } from '../components/Bus'

const defaults = {
  id: 0,
  age: '0',
  event: 'Being born',
  targetVerticies: {
    x: 0,
    y: 0,
    idx: 0,
  },
  currentVerticies: {
    x: -3000,
    y: 0,
    idx: 200
  },
  timeline: null,
  initDelay: 0
}

export default class SnapTimelineMarker {
  constructor (settings) {
    this.settings = Object.assign({}, defaults, settings)
    this.drawSvg()
    this.addListeners()
    return this
  }

  drawSvg () {
    this.svg = new Snap(1, 1).attr({
      x: this.settings.currentVerticies.x,
      y: this.settings.currentVerticies.y
    })

    this.settings.currentVerticies.idx = this.settings.targetVerticies.idx - 2000

    this.svg.line(0, 0, 0, this.settings.id % 2 === 0 ? -60 : 60).attr({
      class: 'marker__line-to-event'
    })

    this.hoverGroup = this.svg.group().attr({
      transform: 'translate(0, 0)',
      class: 'marker__hover'
    })

    this.hoverGroup.circle(0, 0, 34)
    this.hoverGroup.circle(0, 0, 28)

    this.ageGroup = this.svg.group().attr({
      class: 'marker__age'
    })
    this.ageGroup.circle(0, 0, 22).attr({
      class: 'marker__age__background'
    })

    this.addAgeGroupText()
    this.addLabelText()
    this.addCircleClass()

    setTimeout(() => {
      this.animateToTargetVerticies(1700)
    }, this.settings.initDelay)
  }

  update (settings) {
    this.settings = Object.assign(this.settings, settings)
    this.ageGroupText.remove()
    this.labelText.remove()
    this.addAgeGroupText()
    this.animateToTargetVerticies()
    this.addLabelText()
    this.addCircleClass()
  }

  addAgeGroupText () {
    this.ageGroupText = this.ageGroup.text(0, 0, this.settings.age).attr({
      class: 'marker__age__text',
      dy: 7
    })
  }

  addCircleClass () {
    this.svg.attr({
      class: 'marker ' + 'marker--' + this.settings.event.replace(/\s+/g, '-').toLowerCase()
    })
  }

  addLabelText () {
    if (this.settings.event === 'Reaching the height of my career') {
      this.settings.event = 'Reaching the\nheight of\nmy career'
    } else if (this.settings.event === 'Planning my funeral') {
      this.settings.event = 'Planning\nmy funeral'
    } else if (this.settings.event === 'Having a grandchild') {
      this.settings.event = 'Having a\ngrandchild'
    }

    this.labelText = this.svg.text(0, 0, this.settings.event.split('\n')).attr({
      class: this.settings.id % 2 === 0 ? 'marker__event-text marker__event-text--even' : 'marker__event-text marker__event-text--odd'
    })

    this.labelText.selectAll('tspan').forEach((tspan, idx) => {
      tspan.attr({
        x: 0,
        y: 20 * idx
      })
    })
    this.labelText.attr({
      transform: `translate(0, ${this.settings.id % 2 === 0 ? -this.labelText.getBBox().height - 70 : 70})`
    })
  }

  animateToTargetVerticies (animationTime = 500) {
    Snap.animate(this.settings.currentVerticies.idx, this.settings.targetVerticies.idx, (vert) => {
      let verticies = this.settings.timeline.getPointAtLength(vert)
      this.svg.attr({
        x: verticies.x,
        y: verticies.y
      })
    }, animationTime, window.mina.easeinout, () => {
      let verticies = this.settings.timeline.getPointAtLength(this.settings.targetVerticies.idx)
      this.settings.currentVerticies = {
        x: verticies.x,
        y: verticies.y,
        idx: this.settings.targetVerticies.idx
      }
    })
  }

  addListeners () {
    this.svg.click(() => {
      store.commit('setModalDataName', {
        name: this.settings.event,
        feelings: this.settings.feelings,
        attitude: this.settings.attitude,
        cost: this.settings.cost.values,
        costTitle: this.settings.cost.title
      })
      Bus.$emit('openModal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/SnapTimelineMarker.js